import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { Helmet } from 'react-helmet';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface ChinaBreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function ChinaBreadcrumbs({ items }: ChinaBreadcrumbsProps) {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  
  // Build structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": baseUrl
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "China",
        "item": `${baseUrl}/china`
      },
      ...items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 3,
        "name": item.label,
        "item": item.path ? `${baseUrl}${item.path}` : undefined
      }))
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-muted-foreground mb-6">
        <Link to="/" className="hover:text-foreground transition-colors">
          <Home className="h-4 w-4" />
        </Link>
        <ChevronRight className="h-4 w-4" />
        <Link to="/china" className="hover:text-foreground transition-colors">
          China
        </Link>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight className="h-4 w-4" />
            {item.path ? (
              <Link to={item.path} className="hover:text-foreground transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground font-medium">{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
}
